import { createFeature, createReducer, on } from '@ngrx/store';
import { SupplierActions } from './supplier.actions';
import { SupplierState } from './supplier-state.model';

const initialState: SupplierState = {
  suppliers: [],
  isLoading: false,
  error: null,
};

export const supplierFeatureKey = 'supplier';

export const supplierReducer = createReducer(
  initialState,

  on(SupplierActions.loadSuppliers, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(SupplierActions.loadSuppliersSuccess, (state, { suppliers }) => ({
    ...state,
    suppliers,
    isLoading: false,
  })),

  on(SupplierActions.loadSuppliersFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),

  on(SupplierActions.updateSupplier, (state, { id, data }) => ({
    ...state,
    suppliers: state.suppliers.map((supplier) =>
      supplier.id === id ? { ...supplier, ...data } : supplier,
    ),
  })),

  on(SupplierActions.saveSupplierAccess, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(SupplierActions.saveSupplierAccessSuccess, (state) => ({
    ...state,
    isLoading: false,
  })),

  on(SupplierActions.saveSupplierAccessFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),
);

export const supplierFeature = createFeature({
  name: supplierFeatureKey,
  reducer: supplierReducer,
});
